import { Menu, Button, withStyles } from "@material-ui/core";
import appConstants from "../../../../appConstants";
import history from "../../../../utilities/history";

const styles = (theme) => ({
  shipmentSelectionMenu: {
    background: theme.ModalBGColor,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "4px",
  },
  shipmentSelectionMenuItem: {
    display: "flex",
    flexDirection: "column",
  },
  shipmentSelectionActionButton: {
    fontSize: "14px",
    color: theme.gridTextColor,
    justifyContent : "flex-start",
    padding : 8
  },
});

const ShipmentSelectionMenu = ({
  open,
  menuAnchor,
  onClose,
  openSettings,
  classes,
}) => {
  const goToScenarioExplorer = (e) => {
    sessionStorage.setItem("activeSettingsModule", "scenarioExplorer");
    openSettings(e, "/settings");
    onClose();
  };
  const goToShipmentSelection = () => {
    history.push(appConstants.NAV_URLS.SHIPMENT_SELECTION);
  };
  return (
    <Menu
      disablePortal={true}
      getContentAnchorEl={null}
      disableAutoFocusItem={true}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      anchorEl={menuAnchor}
      onClose={onClose}
      MenuListProps={{ disablePadding: true }}
      classes={{
        paper: classes.shipmentSelectionMenu,
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <div className={classes.shipmentSelectionMenuItem}>
        <Button
          className={classes.shipmentSelectionActionButton}
          onClick={goToShipmentSelection}
        >
          + Add / Update Plan
        </Button>
        <Button
          className={classes.shipmentSelectionActionButton}
          onClick={goToScenarioExplorer}
        >
          Switch Plan
        </Button>
      </div>
    </Menu>
  );
};

export default withStyles(styles)(ShipmentSelectionMenu);
